module.exports = __webpack_public_path__ + "fonts/SFUIText-Light.e5d7684e.eot";